export default __webpack_public_path__ + "static/media/visibility.5b8ab45d.svg";